// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IOcrResultDto,
} from '../models/index';
import {
    IOcrResultDtoFromJSON,
    IOcrResultDtoToJSON,
} from '../models/index';

export interface GetOcrOptionsRequest {
    employeeId?: number;
    dependentId?: number;
    serviceOn?: Date;
    amount?: number;
    serviceId?: number;
    providerId?: number;
    overrideRunout?: boolean;
}

export interface GetOcrWithOptionsRequest {
    documentId: number;
    employeeId?: number;
    dependentId?: number;
    serviceOn?: Date;
    amount?: number;
    serviceId?: number;
    overrideRunout?: boolean;
}

export interface RecognizeDocumentRequest {
    documentId: number;
    employeeId?: number;
    overrideRunout?: boolean;
}

/**
 * DocumentOcrControllerApi - interface
 * 
 * @export
 * @interface DocumentOcrControllerApiInterface
 */
export interface DocumentOcrControllerApiInterface {
    /**
     * 
     * @param {number} [employeeId] 
     * @param {number} [dependentId] 
     * @param {Date} [serviceOn] 
     * @param {number} [amount] 
     * @param {number} [serviceId] 
     * @param {number} [providerId] 
     * @param {boolean} [overrideRunout] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentOcrControllerApiInterface
     */
    getOcrOptionsRaw(requestParameters: GetOcrOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrResultDto>>;

    /**
     */
    getOcrOptions(requestParameters: GetOcrOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrResultDto>;

    /**
     * 
     * @param {number} documentId 
     * @param {number} [employeeId] 
     * @param {number} [dependentId] 
     * @param {Date} [serviceOn] 
     * @param {number} [amount] 
     * @param {number} [serviceId] 
     * @param {boolean} [overrideRunout] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentOcrControllerApiInterface
     */
    getOcrWithOptionsRaw(requestParameters: GetOcrWithOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrResultDto>>;

    /**
     */
    getOcrWithOptions(requestParameters: GetOcrWithOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrResultDto>;

    /**
     * 
     * @param {number} documentId 
     * @param {number} [employeeId] 
     * @param {boolean} [overrideRunout] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentOcrControllerApiInterface
     */
    recognizeDocumentRaw(requestParameters: RecognizeDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrResultDto>>;

    /**
     */
    recognizeDocument(requestParameters: RecognizeDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrResultDto>;

}

/**
 * 
 */
export class DocumentOcrControllerApi extends runtime.BaseAPI implements DocumentOcrControllerApiInterface {

    /**
     */
    async getOcrOptionsRaw(requestParameters: GetOcrOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrResultDto>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['dependentId'] != null) {
            queryParameters['dependent_id'] = requestParameters['dependentId'];
        }

        if (requestParameters['serviceOn'] != null) {
            queryParameters['service_on'] = (requestParameters['serviceOn'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['amount'] != null) {
            queryParameters['amount'] = requestParameters['amount'];
        }

        if (requestParameters['serviceId'] != null) {
            queryParameters['service_id'] = requestParameters['serviceId'];
        }

        if (requestParameters['providerId'] != null) {
            queryParameters['provider_id'] = requestParameters['providerId'];
        }

        if (requestParameters['overrideRunout'] != null) {
            queryParameters['override_runout'] = requestParameters['overrideRunout'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/ocr/options`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOcrResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async getOcrOptions(requestParameters: GetOcrOptionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrResultDto> {
        const response = await this.getOcrOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOcrWithOptionsRaw(requestParameters: GetOcrWithOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrResultDto>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling getOcrWithOptions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['dependentId'] != null) {
            queryParameters['dependent_id'] = requestParameters['dependentId'];
        }

        if (requestParameters['serviceOn'] != null) {
            queryParameters['service_on'] = (requestParameters['serviceOn'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['amount'] != null) {
            queryParameters['amount'] = requestParameters['amount'];
        }

        if (requestParameters['serviceId'] != null) {
            queryParameters['service_id'] = requestParameters['serviceId'];
        }

        if (requestParameters['overrideRunout'] != null) {
            queryParameters['override_runout'] = requestParameters['overrideRunout'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/{document-id}/ocr/options`;
        urlPath = urlPath.replace(`{${"document-id"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOcrResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async getOcrWithOptions(requestParameters: GetOcrWithOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrResultDto> {
        const response = await this.getOcrWithOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async recognizeDocumentRaw(requestParameters: RecognizeDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrResultDto>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling recognizeDocument().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['overrideRunout'] != null) {
            queryParameters['override_runout'] = requestParameters['overrideRunout'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/{document-id}/ocr`;
        urlPath = urlPath.replace(`{${"document-id"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOcrResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async recognizeDocument(requestParameters: RecognizeDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrResultDto> {
        const response = await this.recognizeDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
